module.exports = __webpack_public_path__ + "static/media/th.9bf6ec6b.svg";